(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-consultant-quiz"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-skin-quiz]').forEach(function (root) {
  var state = { category: null, q1: null, q2: null, q2h: null, q3h: null };

  var productsEl = root.parentElement.querySelector('[data-skin-consultant-products]');
  var products = {};
  try {
    products = productsEl ? JSON.parse(productsEl.textContent) : {};
  } catch (e) {
    products = {};
  }

  var skinTips = {
    dry: 'dry skin loves extra hydration — layer a richer moisturizer on top.',
    oily: 'oily skin does best with lightweight, non-comedogenic formulas.',
    combination: 'combination skin benefits from balancing morning and night steps differently.',
    sensitive: 'sensitive skin should patch-test and introduce new products slowly.'
  };

  var stepOrder = { '1': 1, '2h': 2, '3h': 3, '2s': 2, '3s': 3, result: 4 };

  function showStep(step) {
    root.querySelectorAll('[data-step]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-step') === String(step));
    });
    root.querySelectorAll('[data-step-dot]').forEach(function (el) {
      var dotStep = Number(el.getAttribute('data-step-dot'));
      el.classList.toggle('is-active', dotStep <= stepOrder[step]);
    });
  }

  // Step 1: Hair or Skin
  root.querySelectorAll('[data-category]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var category = btn.getAttribute('data-category');
      state.category = category;
      btn.classList.add('is-selected');
      if (category === 'hair') {
        showStep('2h');
      } else {
        showStep('2s');
      }
    });
  });

  // Hair questions (Q2H, Q3H)
  root.querySelectorAll('[data-answer="q2h"], [data-answer="q3h"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var question = btn.getAttribute('data-answer');
      var value = btn.getAttribute('data-value');
      state[question] = value;

      root.querySelectorAll('[data-answer="' + question + '"]').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');

      if (question === 'q2h') showStep('3h');
      if (question === 'q3h') showResult();
    });
  });

  // Skin questions (Q1, Q2)
  root.querySelectorAll('[data-answer="q1"], [data-answer="q2"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var question = btn.getAttribute('data-answer');
      var value = btn.getAttribute('data-value');
      state[question] = value;

      root.querySelectorAll('[data-answer="' + question + '"]').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');

      if (question === 'q1') showStep('3s');
      if (question === 'q2') showResult();
    });
  });

  // Back button
  root.querySelectorAll('[data-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var current = root.querySelector('.skin-quiz__step.is-active').getAttribute('data-step');
      if (current === '2h') showStep('1');
      if (current === '3h') showStep('2h');
      if (current === '2s') showStep('1');
      if (current === '3s') showStep('2s');
    });
  });

  // Restart
  var restartBtn = root.querySelector('[data-restart]');
  if (restartBtn) {
    restartBtn.addEventListener('click', function () {
      state = { category: null, q1: null, q2: null, q2h: null, q3h: null };
      root.querySelectorAll('.skin-quiz__card').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      showStep('1');
    });
  }

  function showResult() {
    var pick = state.category === 'hair' 
      ? products[state.q2h] 
      : products[state.q1];
    
    var titleEl = root.querySelector('[data-result-title]');
    var tipEl = root.querySelector('[data-result-tip]');
    var imageEl = root.querySelector('[data-result-image]');
    var productTitleEl = root.querySelector('[data-result-product-title]');
    var priceEl = root.querySelector('[data-result-product-price]');
    var linkEl = root.querySelector('[data-result-link]');

    if (pick) {
      titleEl.textContent = pick.title;
      imageEl.src = pick.image;
      imageEl.alt = pick.title;
      productTitleEl.textContent = pick.title;
      priceEl.textContent = pick.price;
      linkEl.href = pick.url;
    } else {
      titleEl.textContent = 'Coming soon';
      imageEl.removeAttribute('src');
      productTitleEl.textContent = '';
      priceEl.textContent = '';
      linkEl.href = '#';
    }

    // Skin tip vs hair recommendation
    if (state.category === 'skin') {
      tipEl.textContent = skinTips[state.q2] ? 'Since you have ' + state.q2 + ' skin, ' + skinTips[state.q2] : '';
    } else {
      tipEl.textContent = 'Your hair care routine is ready.';
    }

    showStep('result');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-consultation-form"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('[data-skin-consultation]').forEach(function(root) {

  var form = root.querySelector('form');
  var whatsappNumber = (root.getAttribute('data-whatsapp-number') || '').replace(/\D/g, '');

  /* ── i18n config ── */
  var configEl = root.parentElement ? root.parentElement.querySelector('[data-consultation-i18n]') : null;
  var config = {};
  try { config = configEl ? JSON.parse(configEl.textContent) : {}; } catch(e) { config = {}; }

  function lines(val) {
    return String(val || '').split(/\r?\n/).map(function(s){ return s.trim(); }).filter(Boolean);
  }
  var validationLines = lines(config.validation);
  var summaryLines   = lines(config.summary_labels);

  function val(i, fb) { return validationLines[i] || fb; }
  function sum(i, fb) { return summaryLines[i]   || fb; }

  var notProvided = config.not_provided || '—';

  /* ── state ── */
  var state = {
    first_name: '', last_name: '',
    age: 30,
    gender: '', gender_label: '',
    pregnant: '', pregnant_label: '',
    height_cm: 160, height_unit: 'cm',
    weight_kg: 70,
    country_code: '+90', phone: '', email: '',
    solution_type: '', solution_label: '',
    hair_concerns: [], hair_other_text: '',
    facial_concerns: [], facial_other_text: '',
    other_text: ''
  };

  var currentStep = 1;

  /* ── helpers ── */
  function esc(v) {
    return String(v||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  }
  function disp(v) { return v && String(v).trim() ? esc(v) : '<em style="opacity:.4">' + esc(notProvided) + '</em>'; }

  function cmToFt(cm) {
    var totalIn = Math.round(cm / 2.54);
    return Math.floor(totalIn / 12) + "'" + (totalIn % 12) + '"';
  }

  var isRtl = root.getAttribute('dir') === 'rtl';
  function updateSliderFill(slider) {
    var pct = ((Number(slider.value) - Number(slider.min)) / (Number(slider.max) - Number(slider.min))) * 100;
    var fillDir = isRtl ? 'to left' : 'to right';
    slider.style.background = 'linear-gradient(' + fillDir + ', var(--dt-green-500) ' + pct + '%, var(--dt-sand-300) ' + pct + '%)';
  }

  function setValidation(stepEl, msg) {
    var el = stepEl ? stepEl.querySelector('[data-validation]') : null;
    if (el) el.textContent = msg || '';
  }

  /* ── show step ── */
  function showStep(n) {
    currentStep = n;
    root.querySelectorAll('[data-step]').forEach(function(el) {
      el.classList.toggle('is-active', el.getAttribute('data-step') === String(n));
    });
    root.querySelectorAll('[data-step-dot]').forEach(function(el) {
      el.classList.toggle('is-active', Number(el.getAttribute('data-step-dot')) <= n);
    });
    if (n === 8) showBranch(state.solution_type);
    if (n === 9) renderSummary();
    window.requestAnimationFrame(function() { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  }

  function showBranch(type) {
    root.querySelectorAll('[data-branch]').forEach(function(el) {
      el.style.display = el.getAttribute('data-branch') === type ? '' : 'none';
    });
  }

  /* ── validate ── */
  function validateStep(n) {
    var stepEl = root.querySelector('[data-step="' + n + '"]');
    if (!stepEl) return true;
    setValidation(stepEl, '');

    if (n === 1) {
      var fn = root.querySelector('#c-first-name');
      var ln = root.querySelector('#c-last-name');
      if (!fn || !fn.value.trim()) { setValidation(stepEl, val(0, 'Please enter your first name.')); if (fn) fn.focus(); return false; }
      if (!ln || !ln.value.trim()) { setValidation(stepEl, val(1, 'Please enter your last name.')); if (ln) ln.focus(); return false; }
      state.first_name = fn.value.trim();
      state.last_name  = ln.value.trim();
    }

    if (n === 3) {
      if (!state.gender) { setValidation(stepEl, val(2, 'Please select male or female.')); return false; }
      if (state.gender === 'female' && !state.pregnant) { setValidation(stepEl, val(3, 'Please indicate whether you are pregnant.')); return false; }
    }

    if (n === 6) {
      var ph = root.querySelector('#c-phone');
      if (!ph || !ph.value.trim()) { setValidation(stepEl, val(4, 'Please enter your phone number.')); if (ph) ph.focus(); return false; }
      state.phone = ph.value.trim();
      var cc = root.querySelector('[data-country-code]');
      state.country_code = cc ? cc.value : '+90';
      var em = root.querySelector('#c-email');
      state.email = em ? em.value.trim() : '';
    }

    if (n === 8) {
      if (state.solution_type === 'hair') {
        if (!state.hair_concerns.length) { setValidation(stepEl, val(5, 'Please select at least one hair concern.')); return false; }
        var hw = root.querySelector('[data-hair-other]');
        state.hair_other_text = hw ? hw.value.trim() : '';
        if (state.hair_concerns.indexOf('other') !== -1 && !state.hair_other_text) { setValidation(stepEl, val(6, 'Please describe your other hair concern.')); return false; }
      }
      if (state.solution_type === 'facial') {
        if (!state.facial_concerns.length) { setValidation(stepEl, val(7, 'Please select at least one facial concern.')); return false; }
        var fw = root.querySelector('[data-facial-other]');
        state.facial_other_text = fw ? fw.value.trim() : '';
        if (state.facial_concerns.indexOf('other') !== -1 && !state.facial_other_text) { setValidation(stepEl, val(8, 'Please describe your other facial concern.')); return false; }
      }
      if (state.solution_type === 'other') {
        var ot = root.querySelector('[data-other-text]');
        state.other_text = ot ? ot.value.trim() : '';
        if (!state.other_text) { setValidation(stepEl, val(9, 'Please describe your concern.')); if (ot) ot.focus(); return false; }
      }
    }

    return true;
  }

  /* ── sliders ── */
  var ageSlider = root.querySelector('[data-age-slider]');
  var ageDisplay = root.querySelector('[data-age-display]');
  if (ageSlider) {
    updateSliderFill(ageSlider);
    ageSlider.addEventListener('input', function() {
      state.age = Number(ageSlider.value);
      if (ageDisplay) ageDisplay.textContent = state.age;
      updateSliderFill(ageSlider);
    });
  }

  var heightSlider  = root.querySelector('[data-height-slider]');
  var heightDisplay = root.querySelector('[data-height-display]');
  var heightMinEl   = root.querySelector('[data-height-min]');
  var heightMaxEl   = root.querySelector('[data-height-max]');
  var cmUnit = heightSlider ? (heightSlider.getAttribute('data-unit-cm') || 'cm') : 'cm';
  var ftUnit = heightSlider ? (heightSlider.getAttribute('data-unit-ft') || 'ft') : 'ft';

  function updateHeightDisplay() {
    if (!heightSlider) return;
    state.height_cm = Number(heightSlider.value);
    var label = state.height_unit === 'ft' ? cmToFt(state.height_cm) : state.height_cm + ' ' + cmUnit;
    if (heightDisplay) heightDisplay.textContent = label;
    if (heightMinEl) heightMinEl.textContent = state.height_unit === 'ft' ? cmToFt(120) : '120 ' + cmUnit;
    if (heightMaxEl) heightMaxEl.textContent = state.height_unit === 'ft' ? cmToFt(200) : '200 ' + cmUnit;
    updateSliderFill(heightSlider);
  }
  if (heightSlider) { updateHeightDisplay(); heightSlider.addEventListener('input', updateHeightDisplay); }

  root.querySelectorAll('[data-unit-btn]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      state.height_unit = btn.getAttribute('data-unit-btn');
      root.querySelectorAll('[data-unit-btn]').forEach(function(b) { b.classList.toggle('is-active', b === btn); });
      updateHeightDisplay();
    });
  });

  var weightSlider  = root.querySelector('[data-weight-slider]');
  var weightDisplay = root.querySelector('[data-weight-display]');
  var kgUnit = weightSlider ? (weightSlider.getAttribute('data-unit-kg') || 'kg') : 'kg';
  if (weightSlider) {
    updateSliderFill(weightSlider);
    weightSlider.addEventListener('input', function() {
      state.weight_kg = Number(weightSlider.value);
      if (weightDisplay) weightDisplay.textContent = state.weight_kg + ' ' + kgUnit;
      updateSliderFill(weightSlider);
    });
  }

  /* ── gender ── */
  root.querySelectorAll('[data-single="gender"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      state.gender = btn.getAttribute('data-value');
      state.gender_label = btn.getAttribute('data-label') || state.gender;
      root.querySelectorAll('[data-single="gender"]').forEach(function(b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      if (state.gender === 'male') {
        state.pregnant = ''; state.pregnant_label = '';
        root.querySelectorAll('[data-single="pregnant"]').forEach(function(b) { b.classList.remove('is-selected'); });
      }
      var preg = root.querySelector('[data-pregnancy-section]');
      if (preg) preg.classList.toggle('is-visible', state.gender === 'female');
      setValidation(root.querySelector('[data-step="3"]'), '');
    });
  });

  /* ── pregnancy ── */
  root.querySelectorAll('[data-single="pregnant"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      state.pregnant = btn.getAttribute('data-value');
      state.pregnant_label = btn.getAttribute('data-label') || state.pregnant;
      root.querySelectorAll('[data-single="pregnant"]').forEach(function(b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      setValidation(root.querySelector('[data-step="3"]'), '');
    });
  });

  /* ── solution type ── */
  root.querySelectorAll('[data-solution]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      state.solution_type = btn.getAttribute('data-solution');
      state.solution_label = btn.getAttribute('data-label') || state.solution_type;
      state.hair_concerns = []; state.hair_other_text = '';
      state.facial_concerns = []; state.facial_other_text = '';
      state.other_text = '';
      root.querySelectorAll('[data-multi]').forEach(function(b) { b.classList.remove('is-selected'); });
      var hw2 = root.querySelector('[data-hair-other-wrap]');
      var fw2 = root.querySelector('[data-facial-other-wrap]');
      if (hw2) hw2.classList.remove('is-visible');
      if (fw2) fw2.classList.remove('is-visible');
      root.querySelectorAll('[data-solution]').forEach(function(b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      window.setTimeout(function() { showStep(8); }, 180);
    });
  });

  /* ── multi-select ── */
  root.querySelectorAll('[data-multi]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var key   = btn.getAttribute('data-multi');
      var value = btn.getAttribute('data-value') || '';
      var list  = state[key];
      if (list.indexOf(value) === -1) { list.push(value); btn.classList.add('is-selected'); }
      else { state[key] = list.filter(function(v){ return v !== value; }); btn.classList.remove('is-selected'); }
      if (value === 'other') {
        var wrap = key === 'hair_concerns' ? root.querySelector('[data-hair-other-wrap]') : root.querySelector('[data-facial-other-wrap]');
        if (wrap) wrap.classList.toggle('is-visible', state[key].indexOf('other') !== -1);
      }
      setValidation(root.querySelector('[data-step="8"]'), '');
    });
  });

  /* ── next / back ── */
  root.querySelectorAll('[data-next]').forEach(function(btn) {
    btn.addEventListener('click', function() { if (validateStep(currentStep)) showStep(Math.min(currentStep + 1, 9)); });
  });
  root.querySelectorAll('[data-back]').forEach(function(btn) {
    btn.addEventListener('click', function() { if (currentStep > 1) showStep(currentStep - 1); });
  });

  /* ── labels from selected multi buttons ── */
  function getMultiLabels(key) {
    return (state[key] || []).map(function(value) {
      if (value === 'other') return null; // handled separately
      var found = null;
      root.querySelectorAll('[data-multi="' + key + '"]').forEach(function(b) {
        if (b.getAttribute('data-value') === value) found = b.getAttribute('data-label') || value;
      });
      return found || value;
    }).filter(Boolean);
  }

  function heightLabel() {
    return state.height_unit === 'ft' ? cmToFt(state.height_cm) + ' (' + state.height_cm + ' ' + cmUnit + ')' : state.height_cm + ' ' + cmUnit;
  }

  function concernsText() {
    if (state.solution_type === 'hair') {
      var labels = getMultiLabels('hair_concerns');
      if (state.hair_concerns.indexOf('other') !== -1 && state.hair_other_text) labels.push(state.hair_other_text);
      return labels.join(', ');
    }
    if (state.solution_type === 'facial') {
      var labels2 = getMultiLabels('facial_concerns');
      if (state.facial_concerns.indexOf('other') !== -1 && state.facial_other_text) labels2.push(state.facial_other_text);
      return labels2.join(', ');
    }
    if (state.solution_type === 'other') return state.other_text;
    return '';
  }

  function genderDisplayLabel() {
    if (state.gender === 'female' && state.pregnant_label) return state.gender_label + ' — ' + state.pregnant_label;
    return state.gender_label;
  }

  function row(label, value) {
    return '<div class="skin-consultation__summary-row"><span class="skin-consultation__summary-label">' + esc(label) + '</span><span class="skin-consultation__summary-value">' + value + '</span></div>';
  }

  /* ── summary ── */
  function renderSummary() {
    var el = root.querySelector('[data-summary]');
    if (!el) return;
    el.innerHTML =
      row(sum(0,'Name'),     disp(state.first_name + ' ' + state.last_name)) +
      row(sum(1,'Age'),      disp(String(state.age))) +
      row(sum(2,'Gender'),   disp(genderDisplayLabel())) +
      row(sum(3,'Height'),   disp(heightLabel())) +
      row(sum(4,'Weight'),   disp(state.weight_kg + ' ' + kgUnit)) +
      row(sum(5,'Phone'),    disp(state.country_code + ' ' + state.phone)) +
      (state.email ? row(sum(6,'Email'), disp(state.email)) : '') +
      row(sum(7,'Category'), disp(state.solution_label)) +
      row(sum(8,'Concerns'), disp(concernsText()));
  }

  /* ── build message ── */
  function buildMessage(intro) {
    return [
      intro || 'DR.TAGY CONSULTATION', '',
      sum(0,'Name')     + ': ' + state.first_name + ' ' + state.last_name,
      sum(1,'Age')      + ': ' + state.age,
      sum(2,'Gender')   + ': ' + genderDisplayLabel(),
      sum(3,'Height')   + ': ' + heightLabel(),
      sum(4,'Weight')   + ': ' + state.weight_kg + ' ' + kgUnit,
      sum(5,'Phone')    + ': ' + state.country_code + ' ' + state.phone,
      state.email ? sum(6,'Email') + ': ' + state.email : null,
      '',
      sum(7,'Category') + ': ' + state.solution_label,
      sum(8,'Concerns') + ': ' + (concernsText() || notProvided)
    ].filter(function(l){ return l !== null; }).join('\n');
  }

  /* ── consent ── */
  function checkConsent() {
    var cb = root.querySelector('[data-consent]');
    if (!cb || !cb.checked) { setValidation(root.querySelector('[data-step="9"]'), val(10, 'Please agree before continuing.')); return false; }
    setValidation(root.querySelector('[data-step="9"]'), '');
    return true;
  }

  /* ── email ── */
  var emailBtn = root.querySelector('[data-send-email]');
  if (emailBtn) {
    emailBtn.addEventListener('click', function(e) {
      if (!checkConsent()) { e.preventDefault(); return; }
      if (!state.email) { setValidation(root.querySelector('[data-step="9"]'), val(11, 'Please go back and enter your email address.')); e.preventDefault(); return; }
      var body = root.querySelector('[data-contact-body]');
      if (body) body.value = buildMessage(config.email_intro);
    });
  }

  /* ── whatsapp ── */
  var waBtn = root.querySelector('[data-send-whatsapp]');
  if (waBtn) {
    waBtn.addEventListener('click', function() {
      if (!checkConsent()) return;
      if (!whatsappNumber) { setValidation(root.querySelector('[data-step="9"]'), val(12, 'WhatsApp not configured. Add number in settings.')); return; }
      var msg = (config.whatsapp_intro ? config.whatsapp_intro + '\n\n' : '') + buildMessage(config.email_intro);
      window.open('https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
    });
  }

  if (form) { form.addEventListener('submit', function() { var b = root.querySelector('[data-contact-body]'); if (b) b.value = buildMessage(); }); }

  showStep(1);
});


  } catch(e) { console.error(e); }
})();
})();
